import {
  Component,
  DestroyRef,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Feed, FeedAllowedViewsValues } from '../../../../core/models/core.models';

import { AppState } from 'src/app/core/state/app.state';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Observable, tap } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectFeed } from '../../../../core/state';
import { FeedViewsService } from '../../../../core/services/feed-views.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoggerService } from '@services/logger.service';
import { SuiButtonComponent } from '@sui/button';
import { TranslatePipe } from '@ngx-translate/core';

interface View {
  name: FeedAllowedViewsValues;
  icon: IconProp;
  selected: boolean;
}

@Component({
  selector: 'app-feed-views',
  templateUrl: './feed-views.component.html',
  styleUrls: ['./feed-views.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SuiButtonComponent, TranslatePipe],
})
export class FeedViewsComponent implements OnInit {
  feed$: Observable<Feed>;
  feedId: string;

  private destroyRef = inject(DestroyRef);
  private feedViews = inject(FeedViewsService);
  private logger = inject(LoggerService);
  constructor(private store: Store<AppState>) {
    this.feed$ = this.store.select(selectFeed);
  }

  availableViews: View[] = [
    {
      name: 'list',
      icon: ['fas', 'list'],
      selected: true,
    },
    {
      name: 'details',
      icon: ['fas', 'info-circle'],
      selected: true,
    },
    {
      name: 'analytics',
      icon: ['fas', 'chart-line'],
      selected: true,
    },
  ];

  ngOnInit(): void {
    this.feed$
      .pipe(
        tap((feed) => {
          if (feed) {
            this.availableViews = this.availableViews.map((view) => ({
              ...view,
              selected: feed.views?.includes(view.name),
            }));
            this.feedId = feed.id;
          }
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  setView(view: string) {
    this.logger.debug('setView', view);
  }

  toggleSelect(view, selected) {
    this.logger.debug('toggleSelect', view, selected);
    this.feedViews.toggleView(this.feedId, view, selected);

    setTimeout(() => {
      // trigger window:resize event
      window.dispatchEvent(new Event('resize'));
    }, 100);
  }
}
